// Note: co-locating this in routes/index.tsx causes an error where this const is being referenced before it is defined

/** The paths to platform app SPA "pages". Suffixed after movingworlds.org/platform */
export const ROUTES = {
  HOME: '/',
  SOCIAL_ENTERPRISES: '/social-enterprises',
  PROFESSIONALS: '/professionals',
  DASHBOARD: '/dashboard',
  SIGN_UP: '/sign-up',
  SIGN_UP_PRO: '/professional',
  SIGN_UP_REP: '/representative',
  SIGN_UP_PRO_INDIVIDUAL: '/individual',
  SIGN_UP_PRO_CORPORATE: '/corporate',
  SIGN_IN: '/sign-in',
  AUTH: '/auth',
  PROFILE: '/profile',
  ACCOUNT: '/account',
  APPLICATION_START: '/application-start',
  APPLICATION_CLOSED: '/application-closed/:clientName',
  EMAIL_VERIFICATION: '/email-verification',
  EDIT_PROFILE: '/edit-profile',
  PASSWORD_RESET_EMAIL_VERIFICATION: '/password-reset-email-verification',
  FORGOT_PASSWORD: '/forgot-password',
  UPDATE_PASSWORD: '/update-password',
  CHANGE_PASSWORD: '/change-password',
  UPDATE_YOUR_EMAIL: '/update-your-email',
  LOGIN: '/login',
  LOGOUT: '/logout',
  WELCOME_LOGIN: '/welcome-login/:partner',
  ERROR: '/error',
  MY_PROJECTS: '/my-projects',
  DIRECTORY: '/directory',
  DIRECTORY_PROFESSIONALS: '/professionals/:userId',
  DIRECTORY_ORGANIZATIONS: '/organizations/:orgId',
  DIRECTORY_PROJECTS: '/projects/:projectId',
  HEALTHCHECK: '/healthcheck',
  ADMIN: '/admin',
  COMMUNITY: '/community',
  JOB_OPENINGS: '/job-openings',
  EVENTS: '/events',
  FUNDING_OPPORTUNITIES: '/funding-opportunities',
  COMMUNITY_WINS: '/community-wins',
  APPLICATION: '/application',
  BUSINESS_CHALLENGES: '/business-challenges/:organizationId',
  INVITE_ORG_COLLEAGUE: '/invite-colleague',
  PROJECT_HUB: '/project-hub/:assignmentDiscoveryId',
  PROJECT_HUB_TEAM: '/team-project-hub/:projectId',
  CREATE_PROJECT: '/create-project',
  EDIT_PROJECT: '/edit-project/:projectId',
  SEARCH_PROJECTS: '/project-search',
  USER_SEARCH: '/user-search',
  IMPACT_PARTNERS: '/partner/:impactPartnerName',
  COHORT_SELECTION: '/cohort-selection', // Only used currently for SAP
} as const;

export const ADMIN_ROUTES = {
  HOME: '/',
  JOB_POSTINGS: '/job-postings',
  COMMUNITY_WINS: '/community-wins',
  COMMUNITY_ANNOUNCEMENTS: '/community-announcements',
  EVENTS: '/events',
  FUNDING_OPPORTUNITIES: '/funding-opportunities',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/:projectId',
  PROJECT_REVIEW: '/review/:projectId',
  PROJECT_EDIT: '/:projectId/edit',
  INTRODUCTIONS: '/introductions',
  INTRODUCTION_DETAIL: '/:introductionId',
  INTRODUCTION_EDIT: '/:introductionId/edit',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_DETAIL: '/:organizationId',
  ORGANIZATION_EDIT: '/:organizationId/edit',
  ORGANIZATION_REVIEW: '/review/:organizationId',
  PROFESSIONALS: '/professionals',
  PROFESSIONAL_DETAIL: '/:professionalId',
  PROFESSIONAL_REVIEW: '/review/:professionalId',
  MEETINGS: '/meetings',
  EIR_MEETING_DETAIL: '/eir/:meetingId',
  COMMUNITY_MEETING_DETAIL: '/community/:meetingId',
  REPRESENTATIVES: '/representatives',
  PARTNERS: '/partners',
  COHORTS: '/cohorts',
  SEARCH_PROFESSIONALS: '/search-professionals',
  SEARCH_REPRESENTATIVES: '/search-representatives',
  TEAMS: '/teams',
  COHORT_TEAMS: '/:cohortId',
  TEAM_DETAIL: '/:cohortId/:teamId',
} as const;

// TODO: Rework our route constants to make this available without creating a new const
export const SIGN_UP_HREF = `/platform${ROUTES.AUTH}${ROUTES.SIGN_UP}`;
